"use client";

import type { WarehouseLayoutFloorRow } from "../api/client";

type Props = {
  floors: WarehouseLayoutFloorRow[];
  value: string;
  disabled?: boolean;
  className?: string;
  emptyLabel?: string;
  onChange: (layoutId: string | null) => void;
};

/** Native select for assigning a zone to a layout floor (List tab) */
export function WarehouseZoneFloorSelect({
  floors,
  value,
  disabled,
  className,
  emptyLabel = "\u0e8d\u0eb1\u0e87\u0e9a\u0ecd\u0ec8\u0ea2\u0eb9\u0ec8\u0ec0\u0e97\u0eb4\u0e87\u0e9c\u0eb1\u0e87",
  onChange,
}: Props) {
  return (
    <select
      className={
        className ??
        "border-input bg-background h-9 w-full rounded-md border px-3 text-sm"
      }
      value={value}
      disabled={disabled || floors.length === 0}
      onChange={(e) => {
        const next = e.target.value;
        onChange(next === "" ? null : next);
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <option value="">
        {floors.length === 0
          ? "\u0ec0\u0e9e\u0eb5\u0ec8\u0ea1\u0e8a\u0eb1\u0ec9\u0e99\u0e81\u0ec8\u0ead\u0e99"
          : emptyLabel}
      </option>
      {floors.map((f) => (
        <option key={f.id} value={f.id}>
          F{f.floorIndex + 1} · {f.name}
        </option>
      ))}
    </select>
  );
}
